import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SUPPORTED_LANGS } from "@/mocks/site";

function detectLang(): string {
  const nav = (typeof navigator !== "undefined" ? navigator.language : "en") || "en";
  const code = nav.split("-")[0].toLowerCase();
  return SUPPORTED_LANGS.includes(code as never) ? code : "en";
}

export default function RootRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(`/${detectLang()}`, { replace: true });
  }, [navigate]);
  return null;
}